import React, { useState } from 'react';
import './SiteGate.css';

const SITE_CODE = '1309'; // ← le code d'accès au site (à changer ici)
const MAX_ATTEMPTS = 3;
const LOCK_MINUTES = 30;

/* Écran affiché sur mobile / écran trop étroit */
export function DevNotice() {
  return (
    <div className="gate-page">
      <div className="gate-box">
        <h1 className="gate-title">Studio Oblik<sup>®</sup></h1>
        <p className="gate-text">Le site est en cours de développement.</p>
        <p className="gate-text gate-text--dim">Rendez-vous sur grand écran !</p>
      </div>
    </div>
  );
}

/* Porte d'entrée : code simple, 3 tentatives, verrouillage 30 min */
export function SiteGate({ onUnlock }) {
  const [code, setCode] = useState('');
  const [error, setError] = useState('');

  const submit = (e) => {
    e.preventDefault();

    const lockUntil = Number(localStorage.getItem('oblik_gate_lock') || 0);
    if (Date.now() < lockUntil) {
      const minutes = Math.ceil((lockUntil - Date.now()) / 60000);
      setError(`Trop de tentatives. Réessaie dans ${minutes} min.`);
      return;
    }

    if (code.trim().toLowerCase() === SITE_CODE.toLowerCase()) {
      localStorage.removeItem('oblik_gate_attempts');
      localStorage.removeItem('oblik_gate_lock');
      localStorage.setItem('oblik_site_access', '1');
      onUnlock();
    } else {
      const attempts = Number(localStorage.getItem('oblik_gate_attempts') || 0) + 1;
      if (attempts >= MAX_ATTEMPTS) {
        localStorage.setItem('oblik_gate_lock', String(Date.now() + LOCK_MINUTES * 60000));
        localStorage.setItem('oblik_gate_attempts', '0');
        setError(`Trop de tentatives. Accès bloqué ${LOCK_MINUTES} minutes.`);
      } else {
        localStorage.setItem('oblik_gate_attempts', String(attempts));
        setError(`Code incorrect (${attempts}/${MAX_ATTEMPTS})`);
      }
      setCode('');
    }
  };

  return (
    <div className="gate-page">
      <form className="gate-box" onSubmit={submit}>
        <h1 className="gate-title">Studio Oblik<sup>®</sup></h1>
        <p className="gate-text">Ce site est privé pour le moment.</p>
        <input
          type="password"
          className="gate-input"
          placeholder="Code d'accès"
          value={code}
          onChange={(e) => setCode(e.target.value)}
          autoFocus
        />
        {error && <p className="gate-error">{error}</p>}
        <button type="submit" className="gate-btn">Entrer</button>
      </form>
    </div>
  );
}
